import { render, staticRenderFns } from "./less.vue?vue&type=template&id=e24c696e&"
import script from "./less.vue?vue&type=script&lang=js&"
export * from "./less.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24c696e')) {
      api.createRecord('e24c696e', component.options)
    } else {
      api.reload('e24c696e', component.options)
    }
    module.hot.accept("./less.vue?vue&type=template&id=e24c696e&", function () {
      api.rerender('e24c696e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/less.vue"
export default component.exports